@for (error of errors; track error) {
  <span>
    {{customMessage ? customMessage : error}}
  </span>
}
